import React from 'react';
import Navbar from '../../components/core/Navbar';
import Footer from '../../components/core/Footer';
import './InfoPage.css';

const WhatIsNumeraiTournament = () => {
  return (
    <>
      <Navbar />
      <div className="info-page">
        {/* Hero Section */}
        <section className="info-hero">
          <div
            className="info-hero-background"
            style={{
              backgroundImage: `url('/assets/tournament_hero.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          >
            <div className="container">
              <h1>What is the Numerai Tournament?</h1>
              <p className="hero-subheadline">
                A global data science competition with a unique twist
              </p>
            </div>
          </div>
        </section>

        {/* Main Content */}
        <section className="info-content">
          <div className="container">
            <div className="content-section">
              <p>
                The Numerai Tournament is a global data science competition — but with a twist.
              </p>
              <p>
                Instead of trying to predict the next viral video or optimize an ad click, you're helping to build a hedge fund. 
                Numerai provides encrypted financial data and challenges users to submit machine learning predictions that will 
                guide real-world investments.
              </p>
              <p>
                If your model performs well, you earn rewards in the form of cryptocurrency (Numeraire, or $NMR). 
                If you stake your NMR on your own predictions, you can increase your potential rewards — or lose your stake 
                if your model underperforms.
              </p>
              <p>
                In short: you get to compete like a quant at a major hedge fund, without needing a Wall Street résumé.
              </p>
            </div>

            <div className="content-section">
              <h2>Why it matters</h2>
              <p>
                Numerai is one of the first real-world examples of decentralized, collective intelligence in finance. 
                It's not just a game — it's a system where the best ideas actually move money.
              </p>
            </div>

            <div className="content-section">
              <p>
                Curious to hear the story that first got us hooked?<br />
                <a href="https://joincolossus.com/episode/craib-crowdsourcing-predictive-algorithms/" target="_blank" rel="noreferrer">
                Check out this episode of Invest Like the Best featuring Numerai's founder. (Highly recommended.)</a>
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default WhatIsNumeraiTournament; 